module.exports = __webpack_public_path__ + "static/media/BBVAConsumerFinances.ab36e940.jpg";